import React from 'react';
import './PortfolioSimulator.css';
import { PnlContractsInfoButton } from './PnlScalingInfoModal';

const SAMPLE_ROWS = [
  { rank: 1, strategy: 'Nozzle Ninja 5', mon: '\u221E', tue: '\u221E', wed: '\u221E', thur: '0.53', fri: '\u221E', overall: '10.52' },
  { rank: 2, strategy: 'GQ Zero Limit', mon: '\u221E', tue: '\u221E', wed: '\u221E', thur: '0.25', fri: '\u221E', overall: '3.44' },
  { rank: 3, strategy: 'Nozzle Ninja 6', mon: '1.27', tue: '1.35', wed: '1.44', thur: '0.60', fri: '7.87', overall: '2.57' },
  { rank: 4, strategy: 'PrimeBeef', mon: '1.33', tue: '2.17', wed: '5.44', thur: '8.01', fri: '1.36', overall: '2.43' },
  { rank: 5, strategy: 'Tuesday Special (Previous 2.2A)', mon: '\u221E', tue: '\u221E', wed: '1.95', thur: '0.65', fri: '1.31', overall: '2.12' },
  { rank: 6, strategy: 'Grass Fed Prime Beef 2.1 (Normal Trailing)', mon: '\u221E', tue: '\u221E', wed: '2.33', thur: '0.53', fri: '\u221E', overall: '2.06' },
];

/** Sample preview for Portfolio Simulator tab when beta-ended message is shown */
function PortfolioSimulatorSamplePreview() {
  const valueClass = (val) => {
    if (val === '\u221E') return '';
    const n = parseFloat(val);
    if (isNaN(n)) return '';
    return n >= 1 ? 'positive' : 'negative';
  };

  return (
    <div className="portfolio-simulator-container" style={{ opacity: 0.9 }}>
      <div className="portfolio-simulator-header">
        <p className="portfolio-simulator-subtitle">
          Analyze strategy performance by various statistics across different days of the week
        </p>
      </div>
      <div className="portfolio-simulator-controls">
        <div className="control-group">
          <label htmlFor="statistic-select">Statistics:</label>
          <div className="statistic-select-wrapper">
            <select id="statistic-select" className="control-select" disabled value="profitFactor">
              <option value="profitFactor">Profit Factor</option>
            </select>
          </div>
        </div>
        <div className="portfolio-sim-filter-row">
          <div className="control-group">
            <label>Contract Type:</label>
            <div className="contract-type-chips">
              <button type="button" className="contract-type-chip active" disabled>MNQ</button>
              <button type="button" className="contract-type-chip" disabled>NQ</button>
            </div>
          </div>
          <div className="control-group">
            <div className="sim-contracts-label-row">
              <label htmlFor="sample-sim-contract-size">Default Contract Size Multiplier</label>
              <PnlContractsInfoButton
                className="sim-contract-label-info-btn"
                iconSize={14}
                iconColor="rgba(255, 255, 255, 0.65)"
              />
            </div>
            <input id="sample-sim-contract-size" type="number" className="control-input" value="1" readOnly disabled />
          </div>
          <div className="control-group">
            <label>Date Range:</label>
            <select className="control-select" disabled value="all-time">
              <option value="all-time">All Time</option>
            </select>
          </div>
        </div>
      </div>
      <div className="portfolio-simulator-table-wrapper">
        <table className="portfolio-simulator-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th className="sortable active">Strategy</th>
              <th className="sortable">PF Mon</th>
              <th className="sortable">PF Tue</th>
              <th className="sortable">PF Wed</th>
              <th className="sortable">PF Thur</th>
              <th className="sortable">PF Fri</th>
              <th className="sortable active">PF Overall \u2193</th>
            </tr>
          </thead>
          <tbody>
            {SAMPLE_ROWS.map((row) => (
              <tr key={row.strategy}>
                <td className="rank-cell">{row.rank}</td>
                <td className="strategy-name-cell">
                  <span className="strategy-name-link">{row.strategy}</span>
                </td>
                <td className={`stat-cell ${valueClass(row.mon)}`}>{row.mon}</td>
                <td className={`stat-cell ${valueClass(row.tue)}`}>{row.tue}</td>
                <td className={`stat-cell ${valueClass(row.wed)}`}>{row.wed}</td>
                <td className={`stat-cell ${valueClass(row.thur)}`}>{row.thur}</td>
                <td className={`stat-cell ${valueClass(row.fri)}`}>{row.fri}</td>
                <td className={`stat-cell ${valueClass(row.overall)}`}>{row.overall}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="portfolio-simulator-footer">
        <p className="footer-hint">Click column headers to sort • Select strategies to simulate combined performance • Hover over values to see all statistics • Results auto-update on input change</p>
      </div>
    </div>
  );
}

export default PortfolioSimulatorSamplePreview;
